import {
  AgxGlobalSearch,
  CampaignSearcherResult,
  SearchResultType,
} from '@urbanx/agx.ui-components2';
import { Pages } from 'constants/menu';
import { useNavigate } from 'react-router-dom';

const PageLevelSearch = () => {
  const navigate = useNavigate();

  const onItemSelected = (itemType: SearchResultType, item: CampaignSearcherResult): void => {
    switch (itemType) {
      case SearchResultType.ActiveCampaign:
      case SearchResultType.ArchivedCampaign: {
        const campaignRoute = `/${Pages.AGENCIES}/${item.agencyId}/${Pages.CAMPAIGNS}/${item.campaignId}/${Pages.CAMPAIGN_OVERVIEW}`;

        navigate(campaignRoute);

        break;
      }

      case SearchResultType.ActiveContract:
      case SearchResultType.ArchivedContract: {
        if (!item.contractId) {
          throw new Error('A contract search result requires a contract id.');
        }

        const contractRoute = `/${Pages.AGENCIES}/${item.agencyId}/${Pages.CAMPAIGNS}/${item.campaignId}/${Pages.CONTRACTS}/${item.contractId}/${Pages.BUYERS_INFORMATION}`;

        navigate(contractRoute);

        break;
      }

      default:
        console.warn(`Unhandled item type selected: ${itemType}`);
    }
  };

  return (
    <AgxGlobalSearch
      searchForCampaigns
      searchForContracts
      searchForArchivedCampaigns
      searchForArchivedContracts
      onItemSelected={onItemSelected}
    />
  );
};

export default PageLevelSearch;
